import { CSSProperties } from "react";

export const styles: Record<string, CSSProperties> = {
  text: {
    flexGrow: 1,
    textAlign: "center",
  },
  header: {
    flex: 1,
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  placeholder: {
    width: 34,
  },
};
